import { create } from 'zustand';

export type CobrowseStatus = 'idle' | 'requesting-consent' | 'connecting' | 'active' | 'error';

interface CobrowseState {
  /** Current status of the cobrowse session */
  status: CobrowseStatus;
  /** 6-digit session code when active */
  sessionCode: string | null;
  /** Number of agents currently connected */
  agentCount: number;
  /** Error message if status is 'error' */
  error: string | null;
  /**
   * Whether the support chat is open rather than minimised, and how many agent
   * messages arrived while it was not. Reported by the SDK (onChatChange);
   * an SDK too old to report leaves these at their defaults.
   */
  chatOpen: boolean;
  chatUnread: number;

  setStatus: (status: CobrowseStatus) => void;
  setSessionCode: (code: string | null) => void;
  setAgentCount: (count: number) => void;
  setError: (error: string | null) => void;
  setChat: (open: boolean, unread: number) => void;
  reset: () => void;
}

export const useCobrowseStore = create<CobrowseState>((set) => ({
  status: 'idle',
  sessionCode: null,
  agentCount: 0,
  error: null,
  chatOpen: false,
  chatUnread: 0,

  setStatus: (status) => set((s) => ({ status, error: status !== 'error' ? null : s.error })),
  setSessionCode: (sessionCode) => set({ sessionCode }),
  setAgentCount: (agentCount) => set({ agentCount }),
  setError: (error) => set({ error, status: 'error' }),
  setChat: (chatOpen, chatUnread) => set({ chatOpen, chatUnread }),
  reset: () => set({ status: 'idle', sessionCode: null, agentCount: 0, error: null, chatOpen: false, chatUnread: 0 }),
}));
